import { render, staticRenderFns } from "./FormGroupCkeditorReduced.vue?vue&type=template&id=c3ba8cd6"
import script from "./FormGroupCkeditorReduced.vue?vue&type=script&lang=js"
export * from "./FormGroupCkeditorReduced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports